import { PlayerPlatform } from "./usePlayerFeedback";
import { escapeHtml } from "@/utils/CommonUtils";

interface PlayerFeedbackEmailInput {
  email: string;
  userId: string;
  platform: PlayerPlatform;
  opinion: string;
}

function buildContent({
  email,
  userId,
  platform,
  opinion,
}: PlayerFeedbackEmailInput): string {
  const opinionHtml = escapeHtml(opinion).replaceAll("\n", "<br/>");
  return [
    `<b>User Email:</b> ${escapeHtml(email)}`,
    `<b>User ID:</b> ${escapeHtml(userId)}`,
    `<b>Platform:</b> ${platform}`,
    `<b>Feedback Content:</b><br/>${opinionHtml}`,
  ].join("<br/><br/>");
}

export async function sendPlayerFeedbackEmail(
  input: PlayerFeedbackEmailInput,
): Promise<void> {
  const formData = new FormData();
  formData.append("emailTo", input.email);
  formData.append("topic", input.platform);
  formData.append("category", "player-feedback");
  formData.append("content", buildContent(input));

  const res = await fetch("/api/support/send-ask/", {
    method: "POST",
    body: formData,
  });
  if (!res.ok) {
    throw new Error(`send-ask failed: ${res.status}`);
  }
}
